<template>
  <div>
    <TFEN v-if="$i18n.locale === 'en'"></TFEN>
    <TFCN v-if="$i18n.locale === 'zh'"></TFCN>
  </div>
</template>

<script>
import TFEN from "./T-F-Grad-2023-EN.vue";
import TFCN from "./T-F-Grad-2023-CN.vue";
export default {
  name: "T-F-Under-Grad-2023",
  components: { TFEN, TFCN },
};
</script>

<style scoped></style>
